// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_iso4217 from "../../commonapis/gen/buhta_common_v1_iso4217.js";
import * as Buhta_kassaapis__Buhta_kassa_v1_types from "./buhta_kassa_v1_types.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_info from "./buhta_kassa_v1alpha1_kkm_info.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_wkt__Google_protobuf_timestamp from "../../third_party/google_wkt/gen/google_protobuf_timestamp.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt.ml",
      235,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "ReceiptNote"
                          ],
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "Receipt"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ReceiptItem"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ReceiptPayment"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ReceiptTax"
                    ]
                  ]
                },
                "V1alpha1"
              ]]
          },
          "Kassa"
        ]]
    });

const Kassa = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt.ml",
      431,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ReceiptNote"
                    ],
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Receipt"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ReceiptItem"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ReceiptPayment"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ReceiptTax"
              ]
            ]
          },
          "V1alpha1"
        ]]
    });

const V1alpha1 = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt.ml",
      625,
      10
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ReceiptNote"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Receipt"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ReceiptItem"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ReceiptPayment"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ReceiptTax"
        ]
      ]
    });

const Receipt = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt.ml",
      711,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ReceiptNote"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ReceiptItem = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt.ml",
      923,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ReceiptPayment = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt.ml",
      1020,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ReceiptTax = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt.ml",
      1086,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ReceiptNote = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt.ml",
      744,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.kassa.v1alpha1.Receipt.ReceiptNote";
}

function make(note_typeOpt, versionOpt, linesOpt, param) {
  const note_type = note_typeOpt !== undefined ? note_typeOpt : 0;
  const version = versionOpt !== undefined ? versionOpt : 0;
  const lines = linesOpt !== undefined ? linesOpt : /* [] */0;
  return {
          note_type: note_type,
          version: version,
          lines: lines
        };
}

const merge_note_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "note_type",
            "noteType"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_version = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "version",
            "version"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_lines = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            3,
            "lines",
            "lines"
          ],
          Ocaml_protoc_plugin__Spec.string,
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge(t1, t2) {
  return {
          note_type: Curry._2(merge_note_type, t1.note_type, t2.note_type),
          version: Curry._2(merge_version, t1.version, t2.version),
          lines: Curry._2(merge_lines, t1.lines, t2.lines)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "note_type",
                    "noteType"
                  ],
                  Ocaml_protoc_plugin__Spec.int32_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "version",
                        "version"
                      ],
                      Ocaml_protoc_plugin__Spec.int32_int,
                      0
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                          [
                            3,
                            "lines",
                            "lines"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          Ocaml_protoc_plugin__Spec.not_packed
                        ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._4(serialize, writer, param.note_type, param.version, param.lines);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(note_type, version, lines) {
  return {
          note_type: note_type,
          version: version,
          lines: lines
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.Receipt.ReceiptNote", spec(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.note_type, param.version, param.lines);
  };
}

function constructor$1(note_type, version, lines) {
  return {
          note_type: note_type,
          version: version,
          lines: lines
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.Receipt.ReceiptNote", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ReceiptNote, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.kassa.v1alpha1.Receipt";
}

function make$1(kkm_idOpt, idOpt, shift_idOpt, serial_idOpt, serial_shift_idOpt, issue_time, operation_typeOpt, domain_typeOpt, payment_typeOpt, itemsOpt, paymentsOpt, currency_codeOpt, subtotal_amountOpt, total_amountOpt, taxesOpt, taken_amount, change_amount, cashier_codeOpt, cashier_nameOpt, receipt_num, org, kkm, ofd_receipt_idOpt, ofd_qr_codeOpt, notesOpt, param) {
  const kkm_id = kkm_idOpt !== undefined ? kkm_idOpt : 0;
  const id = idOpt !== undefined ? idOpt : "";
  const shift_id = shift_idOpt !== undefined ? shift_idOpt : 0;
  const serial_id = serial_idOpt !== undefined ? serial_idOpt : 0;
  const serial_shift_id = serial_shift_idOpt !== undefined ? serial_shift_idOpt : 0;
  const operation_type = operation_typeOpt !== undefined ? operation_typeOpt : Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType.from_int_exn, 0);
  const domain_type = domain_typeOpt !== undefined ? domain_typeOpt : Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.DomainType.from_int_exn, 0);
  const payment_type = payment_typeOpt !== undefined ? payment_typeOpt : Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.PaymentType.from_int_exn, 0);
  const items = itemsOpt !== undefined ? itemsOpt : /* [] */0;
  const payments = paymentsOpt !== undefined ? paymentsOpt : /* [] */0;
  const currency_code = currency_codeOpt !== undefined ? currency_codeOpt : Curry._1(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency.from_int_exn, 0);
  const subtotal_amount = subtotal_amountOpt !== undefined ? subtotal_amountOpt : "";
  const total_amount = total_amountOpt !== undefined ? total_amountOpt : "";
  const taxes = taxesOpt !== undefined ? taxesOpt : /* [] */0;
  const cashier_code = cashier_codeOpt !== undefined ? cashier_codeOpt : 0;
  const cashier_name = cashier_nameOpt !== undefined ? cashier_nameOpt : "";
  const ofd_receipt_id = ofd_receipt_idOpt !== undefined ? ofd_receipt_idOpt : "";
  const ofd_qr_code = ofd_qr_codeOpt !== undefined ? ofd_qr_codeOpt : "";
  const notes = notesOpt !== undefined ? notesOpt : /* [] */0;
  return {
          kkm_id: kkm_id,
          id: id,
          shift_id: shift_id,
          serial_id: serial_id,
          serial_shift_id: serial_shift_id,
          issue_time: issue_time,
          operation_type: operation_type,
          domain_type: domain_type,
          payment_type: payment_type,
          items: items,
          payments: payments,
          currency_code: currency_code,
          subtotal_amount: subtotal_amount,
          total_amount: total_amount,
          taxes: taxes,
          taken_amount: taken_amount,
          change_amount: change_amount,
          cashier_code: cashier_code,
          cashier_name: cashier_name,
          receipt_num: receipt_num,
          org: org,
          kkm: kkm,
          ofd_receipt_id: ofd_receipt_id,
          ofd_qr_code: ofd_qr_code,
          notes: notes
        };
}

const merge_kkm_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "kkm_id",
            "kkmId"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_shift_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "shift_id",
            "shiftId"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_serial_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            4,
            "serial_id",
            "serialId"
          ],
          Ocaml_protoc_plugin__Spec.int64_int,
          0
        ]));

const merge_serial_shift_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            5,
            "serial_shift_id",
            "serialShiftId"
          ],
          Ocaml_protoc_plugin__Spec.int64_int,
          0
        ]));

const $$let = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_issue_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            6,
            "issue_time",
            "issueTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

const merge_operation_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            7,
            "operation_type",
            "operationType"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType),
          Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType.from_int_exn, 0)
        ]));

const merge_domain_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            8,
            "domain_type",
            "domainType"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.DomainType),
          Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.DomainType.from_int_exn, 0)
        ]));

const merge_payment_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            9,
            "payment_type",
            "paymentType"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.PaymentType),
          Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.PaymentType.from_int_exn, 0)
        ]));

const merge_items = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            10,
            "items",
            "items"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ReceiptItem.name,
                make: ReceiptItem.make,
                from_proto: ReceiptItem.from_proto,
                from_proto_exn: ReceiptItem.from_proto_exn,
                to_proto: ReceiptItem.to_proto,
                to_proto$p: ReceiptItem.to_proto$p,
                merge: ReceiptItem.merge,
                to_json: ReceiptItem.to_json,
                from_json_exn: ReceiptItem.from_json_exn,
                from_json: ReceiptItem.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

const merge_payments = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            11,
            "payments",
            "payments"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ReceiptPayment.name,
                make: ReceiptPayment.make,
                from_proto: ReceiptPayment.from_proto,
                from_proto_exn: ReceiptPayment.from_proto_exn,
                to_proto: ReceiptPayment.to_proto,
                to_proto$p: ReceiptPayment.to_proto$p,
                merge: ReceiptPayment.merge,
                to_json: ReceiptPayment.to_json,
                from_json_exn: ReceiptPayment.from_json_exn,
                from_json: ReceiptPayment.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

const merge_currency_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            12,
            "currency_code",
            "currencyCode"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency),
          Curry._1(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency.from_int_exn, 0)
        ]));

const merge_subtotal_amount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            13,
            "subtotal_amount",
            "subtotalAmount"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_total_amount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            14,
            "total_amount",
            "totalAmount"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_taxes = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            15,
            "taxes",
            "taxes"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ReceiptTax.name,
                make: ReceiptTax.make,
                from_proto: ReceiptTax.from_proto,
                from_proto_exn: ReceiptTax.from_proto_exn,
                to_proto: ReceiptTax.to_proto,
                to_proto$p: ReceiptTax.to_proto$p,
                merge: ReceiptTax.merge,
                to_json: ReceiptTax.to_json,
                from_json_exn: ReceiptTax.from_json_exn,
                from_json: ReceiptTax.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

const merge_taken_amount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            16,
            "taken_amount",
            "takenAmount"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_change_amount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            17,
            "change_amount",
            "changeAmount"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_cashier_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            18,
            "cashier_code",
            "cashierCode"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_cashier_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            19,
            "cashier_name",
            "cashierName"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_receipt_num = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            20,
            "receipt_num",
            "receiptNum"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const $$let$1 = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_info.Buhta.Kassa.V1alpha1.OrgInfo;

const merge_org = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            29,
            "org",
            "org"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

const $$let$2 = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_info.Buhta.Kassa.V1alpha1.KkmInfo;

const merge_kkm = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            30,
            "kkm",
            "kkm"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              })
        ]));

const merge_ofd_receipt_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            31,
            "ofd_receipt_id",
            "ofdReceiptId"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_ofd_qr_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            32,
            "ofd_qr_code",
            "ofdQrCode"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_notes = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            34,
            "notes",
            "notes"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ReceiptNote.name,
                make: ReceiptNote.make,
                from_proto: ReceiptNote.from_proto,
                from_proto_exn: ReceiptNote.from_proto_exn,
                to_proto: ReceiptNote.to_proto,
                to_proto$p: ReceiptNote.to_proto$p,
                merge: ReceiptNote.merge,
                to_json: ReceiptNote.to_json,
                from_json_exn: ReceiptNote.from_json_exn,
                from_json: ReceiptNote.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$1(t1, t2) {
  return {
          kkm_id: Curry._2(merge_kkm_id, t1.kkm_id, t2.kkm_id),
          id: Curry._2(merge_id, t1.id, t2.id),
          shift_id: Curry._2(merge_shift_id, t1.shift_id, t2.shift_id),
          serial_id: Curry._2(merge_serial_id, t1.serial_id, t2.serial_id),
          serial_shift_id: Curry._2(merge_serial_shift_id, t1.serial_shift_id, t2.serial_shift_id),
          issue_time: Curry._2(merge_issue_time, t1.issue_time, t2.issue_time),
          operation_type: Curry._2(merge_operation_type, t1.operation_type, t2.operation_type),
          domain_type: Curry._2(merge_domain_type, t1.domain_type, t2.domain_type),
          payment_type: Curry._2(merge_payment_type, t1.payment_type, t2.payment_type),
          items: Curry._2(merge_items, t1.items, t2.items),
          payments: Curry._2(merge_payments, t1.payments, t2.payments),
          currency_code: Curry._2(merge_currency_code, t1.currency_code, t2.currency_code),
          subtotal_amount: Curry._2(merge_subtotal_amount, t1.subtotal_amount, t2.subtotal_amount),
          total_amount: Curry._2(merge_total_amount, t1.total_amount, t2.total_amount),
          taxes: Curry._2(merge_taxes, t1.taxes, t2.taxes),
          taken_amount: Curry._2(merge_taken_amount, t1.taken_amount, t2.taken_amount),
          change_amount: Curry._2(merge_change_amount, t1.change_amount, t2.change_amount),
          cashier_code: Curry._2(merge_cashier_code, t1.cashier_code, t2.cashier_code),
          cashier_name: Curry._2(merge_cashier_name, t1.cashier_name, t2.cashier_name),
          receipt_num: Curry._2(merge_receipt_num, t1.receipt_num, t2.receipt_num),
          org: Curry._2(merge_org, t1.org, t2.org),
          kkm: Curry._2(merge_kkm, t1.kkm, t2.kkm),
          ofd_receipt_id: Curry._2(merge_ofd_receipt_id, t1.ofd_receipt_id, t2.ofd_receipt_id),
          ofd_qr_code: Curry._2(merge_ofd_qr_code, t1.ofd_qr_code, t2.ofd_qr_code),
          notes: Curry._2(merge_notes, t1.notes, t2.notes)
        };
}

function spec$1(param) {
  const $$let = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$1 = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_info.Buhta.Kassa.V1alpha1.OrgInfo;
  const $$let$2 = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_info.Buhta.Kassa.V1alpha1.KkmInfo;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "kkm_id",
                    "kkmId"
                  ],
                  Ocaml_protoc_plugin__Spec.int32_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "id",
                        "id"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "shift_id",
                            "shiftId"
                          ],
                          Ocaml_protoc_plugin__Spec.int32_int,
                          0
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                4,
                                "serial_id",
                                "serialId"
                              ],
                              Ocaml_protoc_plugin__Spec.int64_int,
                              0
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                  [
                                    5,
                                    "serial_shift_id",
                                    "serialShiftId"
                                  ],
                                  Ocaml_protoc_plugin__Spec.int64_int,
                                  0
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                      [
                                        6,
                                        "issue_time",
                                        "issueTime"
                                      ],
                                      Ocaml_protoc_plugin__Spec.message({
                                            name: $$let.name,
                                            make: $$let.make,
                                            from_proto: $$let.from_proto,
                                            from_proto_exn: $$let.from_proto_exn,
                                            to_proto: $$let.to_proto,
                                            to_proto$p: $$let.to_proto$p,
                                            merge: $$let.merge,
                                            to_json: $$let.to_json,
                                            from_json_exn: $$let.from_json_exn,
                                            from_json: $$let.from_json
                                          })
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                          [
                                            7,
                                            "operation_type",
                                            "operationType"
                                          ],
                                          Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType),
                                          Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType.from_int_exn, 0)
                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                              [
                                                8,
                                                "domain_type",
                                                "domainType"
                                              ],
                                              Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.DomainType),
                                              Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.DomainType.from_int_exn, 0)
                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                  [
                                                    9,
                                                    "payment_type",
                                                    "paymentType"
                                                  ],
                                                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.PaymentType),
                                                  Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.PaymentType.from_int_exn, 0)
                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                                                      [
                                                        10,
                                                        "items",
                                                        "items"
                                                      ],
                                                      Ocaml_protoc_plugin__Spec.message({
                                                            name: ReceiptItem.name,
                                                            make: ReceiptItem.make,
                                                            from_proto: ReceiptItem.from_proto,
                                                            from_proto_exn: ReceiptItem.from_proto_exn,
                                                            to_proto: ReceiptItem.to_proto,
                                                            to_proto$p: ReceiptItem.to_proto$p,
                                                            merge: ReceiptItem.merge,
                                                            to_json: ReceiptItem.to_json,
                                                            from_json_exn: ReceiptItem.from_json_exn,
                                                            from_json: ReceiptItem.from_json
                                                          }),
                                                      Ocaml_protoc_plugin__Spec.not_packed
                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                                                          [
                                                            11,
                                                            "payments",
                                                            "payments"
                                                          ],
                                                          Ocaml_protoc_plugin__Spec.message({
                                                                name: ReceiptPayment.name,
                                                                make: ReceiptPayment.make,
                                                                from_proto: ReceiptPayment.from_proto,
                                                                from_proto_exn: ReceiptPayment.from_proto_exn,
                                                                to_proto: ReceiptPayment.to_proto,
                                                                to_proto$p: ReceiptPayment.to_proto$p,
                                                                merge: ReceiptPayment.merge,
                                                                to_json: ReceiptPayment.to_json,
                                                                from_json_exn: ReceiptPayment.from_json_exn,
                                                                from_json: ReceiptPayment.from_json
                                                              }),
                                                          Ocaml_protoc_plugin__Spec.not_packed
                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                              [
                                                                12,
                                                                "currency_code",
                                                                "currencyCode"
                                                              ],
                                                              Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency),
                                                              Curry._1(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency.from_int_exn, 0)
                                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                  [
                                                                    13,
                                                                    "subtotal_amount",
                                                                    "subtotalAmount"
                                                                  ],
                                                                  Ocaml_protoc_plugin__Spec.string,
                                                                  ""
                                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                      [
                                                                        14,
                                                                        "total_amount",
                                                                        "totalAmount"
                                                                      ],
                                                                      Ocaml_protoc_plugin__Spec.string,
                                                                      ""
                                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                                                                          [
                                                                            15,
                                                                            "taxes",
                                                                            "taxes"
                                                                          ],
                                                                          Ocaml_protoc_plugin__Spec.message({
                                                                                name: ReceiptTax.name,
                                                                                make: ReceiptTax.make,
                                                                                from_proto: ReceiptTax.from_proto,
                                                                                from_proto_exn: ReceiptTax.from_proto_exn,
                                                                                to_proto: ReceiptTax.to_proto,
                                                                                to_proto$p: ReceiptTax.to_proto$p,
                                                                                merge: ReceiptTax.merge,
                                                                                to_json: ReceiptTax.to_json,
                                                                                from_json_exn: ReceiptTax.from_json_exn,
                                                                                from_json: ReceiptTax.from_json
                                                                              }),
                                                                          Ocaml_protoc_plugin__Spec.not_packed
                                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                              [
                                                                                16,
                                                                                "taken_amount",
                                                                                "takenAmount"
                                                                              ],
                                                                              Ocaml_protoc_plugin__Spec.string
                                                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                                  [
                                                                                    17,
                                                                                    "change_amount",
                                                                                    "changeAmount"
                                                                                  ],
                                                                                  Ocaml_protoc_plugin__Spec.string
                                                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                                      [
                                                                                        18,
                                                                                        "cashier_code",
                                                                                        "cashierCode"
                                                                                      ],
                                                                                      Ocaml_protoc_plugin__Spec.int32_int,
                                                                                      0
                                                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                                          [
                                                                                            19,
                                                                                            "cashier_name",
                                                                                            "cashierName"
                                                                                          ],
                                                                                          Ocaml_protoc_plugin__Spec.string,
                                                                                          ""
                                                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                                              [
                                                                                                20,
                                                                                                "receipt_num",
                                                                                                "receiptNum"
                                                                                              ],
                                                                                              Ocaml_protoc_plugin__Spec.string
                                                                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                                                  [
                                                                                                    29,
                                                                                                    "org",
                                                                                                    "org"
                                                                                                  ],
                                                                                                  Ocaml_protoc_plugin__Spec.message({
                                                                                                        name: $$let$1.name,
                                                                                                        make: $$let$1.make,
                                                                                                        from_proto: $$let$1.from_proto,
                                                                                                        from_proto_exn: $$let$1.from_proto_exn,
                                                                                                        to_proto: $$let$1.to_proto,
                                                                                                        to_proto$p: $$let$1.to_proto$p,
                                                                                                        merge: $$let$1.merge,
                                                                                                        to_json: $$let$1.to_json,
                                                                                                        from_json_exn: $$let$1.from_json_exn,
                                                                                                        from_json: $$let$1.from_json
                                                                                                      })
                                                                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                                                      [
                                                                                                        30,
                                                                                                        "kkm",
                                                                                                        "kkm"
                                                                                                      ],
                                                                                                      Ocaml_protoc_plugin__Spec.message({
                                                                                                            name: $$let$2.name,
                                                                                                            make: $$let$2.make,
                                                                                                            from_proto: $$let$2.from_proto,
                                                                                                            from_proto_exn: $$let$2.from_proto_exn,
                                                                                                            to_proto: $$let$2.to_proto,
                                                                                                            to_proto$p: $$let$2.to_proto$p,
                                                                                                            merge: $$let$2.merge,
                                                                                                            to_json: $$let$2.to_json,
                                                                                                            from_json_exn: $$let$2.from_json_exn,
                                                                                                            from_json: $$let$2.from_json
                                                                                                          })
                                                                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                                                          [
                                                                                                            31,
                                                                                                            "ofd_receipt_id",
                                                                                                            "ofdReceiptId"
                                                                                                          ],
                                                                                                          Ocaml_protoc_plugin__Spec.string,
                                                                                                          ""
                                                                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                                                              [
                                                                                                                32,
                                                                                                                "ofd_qr_code",
                                                                                                                "ofdQrCode"
                                                                                                              ],
                                                                                                              Ocaml_protoc_plugin__Spec.string,
                                                                                                              ""
                                                                                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                                                                                                                  [
                                                                                                                    34,
                                                                                                                    "notes",
                                                                                                                    "notes"
                                                                                                                  ],
                                                                                                                  Ocaml_protoc_plugin__Spec.message({
                                                                                                                        name: ReceiptNote.name,
                                                                                                                        make: ReceiptNote.make,
                                                                                                                        from_proto: ReceiptNote.from_proto,
                                                                                                                        from_proto_exn: ReceiptNote.from_proto_exn,
                                                                                                                        to_proto: ReceiptNote.to_proto,
                                                                                                                        to_proto$p: ReceiptNote.to_proto$p,
                                                                                                                        merge: ReceiptNote.merge,
                                                                                                                        to_json: ReceiptNote.to_json,
                                                                                                                        from_json_exn: ReceiptNote.from_json_exn,
                                                                                                                        from_json: ReceiptNote.from_json
                                                                                                                      }),
                                                                                                                  Ocaml_protoc_plugin__Spec.not_packed
                                                                                                                ]), Ocaml_protoc_plugin__Spec.nil)))))))))))))))))))))))));
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry.app(serialize$1, [
        writer,
        param.kkm_id,
        param.id,
        param.shift_id,
        param.serial_id,
        param.serial_shift_id,
        param.issue_time,
        param.operation_type,
        param.domain_type,
        param.payment_type,
        param.items,
        param.payments,
        param.currency_code,
        param.subtotal_amount,
        param.total_amount,
        param.taxes,
        param.taken_amount,
        param.change_amount,
        param.cashier_code,
        param.cashier_name,
        param.receipt_num,
        param.org,
        param.kkm,
        param.ofd_receipt_id,
        param.ofd_qr_code,
        param.notes
      ]);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(kkm_id, id, shift_id, serial_id, serial_shift_id, issue_time, operation_type, domain_type, payment_type, items, payments, currency_code, subtotal_amount, total_amount, taxes, taken_amount, change_amount, cashier_code, cashier_name, receipt_num, org, kkm, ofd_receipt_id, ofd_qr_code, notes) {
  return {
          kkm_id: kkm_id,
          id: id,
          shift_id: shift_id,
          serial_id: serial_id,
          serial_shift_id: serial_shift_id,
          issue_time: issue_time,
          operation_type: operation_type,
          domain_type: domain_type,
          payment_type: payment_type,
          items: items,
          payments: payments,
          currency_code: currency_code,
          subtotal_amount: subtotal_amount,
          total_amount: total_amount,
          taxes: taxes,
          taken_amount: taken_amount,
          change_amount: change_amount,
          cashier_code: cashier_code,
          cashier_name: cashier_name,
          receipt_num: receipt_num,
          org: org,
          kkm: kkm,
          ofd_receipt_id: ofd_receipt_id,
          ofd_qr_code: ofd_qr_code,
          notes: notes
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.Receipt", spec$1(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
                param.kkm_id,
                param.id,
                param.shift_id,
                param.serial_id,
                param.serial_shift_id,
                param.issue_time,
                param.operation_type,
                param.domain_type,
                param.payment_type,
                param.items,
                param.payments,
                param.currency_code,
                param.subtotal_amount,
                param.total_amount,
                param.taxes,
                param.taken_amount,
                param.change_amount,
                param.cashier_code,
                param.cashier_name,
                param.receipt_num,
                param.org,
                param.kkm,
                param.ofd_receipt_id,
                param.ofd_qr_code,
                param.notes
              ]);
  };
}

function constructor$3(kkm_id, id, shift_id, serial_id, serial_shift_id, issue_time, operation_type, domain_type, payment_type, items, payments, currency_code, subtotal_amount, total_amount, taxes, taken_amount, change_amount, cashier_code, cashier_name, receipt_num, org, kkm, ofd_receipt_id, ofd_qr_code, notes) {
  return {
          kkm_id: kkm_id,
          id: id,
          shift_id: shift_id,
          serial_id: serial_id,
          serial_shift_id: serial_shift_id,
          issue_time: issue_time,
          operation_type: operation_type,
          domain_type: domain_type,
          payment_type: payment_type,
          items: items,
          payments: payments,
          currency_code: currency_code,
          subtotal_amount: subtotal_amount,
          total_amount: total_amount,
          taxes: taxes,
          taken_amount: taken_amount,
          change_amount: change_amount,
          cashier_code: cashier_code,
          cashier_name: cashier_name,
          receipt_num: receipt_num,
          org: org,
          kkm: kkm,
          ofd_receipt_id: ofd_receipt_id,
          ofd_qr_code: ofd_qr_code,
          notes: notes
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.Receipt", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ReceiptNote"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, Receipt, {
      ReceiptNote: ReceiptNote,
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.kassa.v1alpha1.ReceiptItem";
}

function make$2(item_typeOpt, nameOpt, section_codeOpt, section_nameOpt, currency_codeOpt, item_priceOpt, qtyOpt, measure_unit_codeOpt, measure_unitOpt, measure_unit_shortOpt, subtotal_amountOpt, total_amountOpt, untaxedOpt, param) {
  const item_type = item_typeOpt !== undefined ? item_typeOpt : Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.ItemType.from_int_exn, 0);
  const name = nameOpt !== undefined ? nameOpt : "";
  const section_code = section_codeOpt !== undefined ? section_codeOpt : "";
  const section_name = section_nameOpt !== undefined ? section_nameOpt : "";
  const currency_code = currency_codeOpt !== undefined ? currency_codeOpt : Curry._1(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency.from_int_exn, 0);
  const item_price = item_priceOpt !== undefined ? item_priceOpt : "";
  const qty = qtyOpt !== undefined ? qtyOpt : "";
  const measure_unit_code = measure_unit_codeOpt !== undefined ? measure_unit_codeOpt : 0;
  const measure_unit = measure_unitOpt !== undefined ? measure_unitOpt : "";
  const measure_unit_short = measure_unit_shortOpt !== undefined ? measure_unit_shortOpt : "";
  const subtotal_amount = subtotal_amountOpt !== undefined ? subtotal_amountOpt : "";
  const total_amount = total_amountOpt !== undefined ? total_amountOpt : "";
  const untaxed = untaxedOpt !== undefined ? untaxedOpt : false;
  return {
          item_type: item_type,
          name: name,
          section_code: section_code,
          section_name: section_name,
          currency_code: currency_code,
          item_price: item_price,
          qty: qty,
          measure_unit_code: measure_unit_code,
          measure_unit: measure_unit,
          measure_unit_short: measure_unit_short,
          subtotal_amount: subtotal_amount,
          total_amount: total_amount,
          untaxed: untaxed
        };
}

const merge_item_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "item_type",
            "itemType"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.ItemType),
          Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.ItemType.from_int_exn, 0)
        ]));

const merge_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            6,
            "name",
            "name"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_section_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            7,
            "section_code",
            "sectionCode"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_section_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            8,
            "section_name",
            "sectionName"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_currency_code$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            9,
            "currency_code",
            "currencyCode"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency),
          Curry._1(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency.from_int_exn, 0)
        ]));

const merge_item_price = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            10,
            "item_price",
            "itemPrice"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_qty = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            11,
            "qty",
            "qty"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_measure_unit_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            12,
            "measure_unit_code",
            "measureUnitCode"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_measure_unit = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            13,
            "measure_unit",
            "measureUnit"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_measure_unit_short = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            14,
            "measure_unit_short",
            "measureUnitShort"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_subtotal_amount$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            15,
            "subtotal_amount",
            "subtotalAmount"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_total_amount$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            16,
            "total_amount",
            "totalAmount"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_untaxed = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            17,
            "untaxed",
            "untaxed"
          ],
          Ocaml_protoc_plugin__Spec.bool,
          false
        ]));

function merge$2(t1, t2) {
  return {
          item_type: Curry._2(merge_item_type, t1.item_type, t2.item_type),
          name: Curry._2(merge_name, t1.name, t2.name),
          section_code: Curry._2(merge_section_code, t1.section_code, t2.section_code),
          section_name: Curry._2(merge_section_name, t1.section_name, t2.section_name),
          currency_code: Curry._2(merge_currency_code$1, t1.currency_code, t2.currency_code),
          item_price: Curry._2(merge_item_price, t1.item_price, t2.item_price),
          qty: Curry._2(merge_qty, t1.qty, t2.qty),
          measure_unit_code: Curry._2(merge_measure_unit_code, t1.measure_unit_code, t2.measure_unit_code),
          measure_unit: Curry._2(merge_measure_unit, t1.measure_unit, t2.measure_unit),
          measure_unit_short: Curry._2(merge_measure_unit_short, t1.measure_unit_short, t2.measure_unit_short),
          subtotal_amount: Curry._2(merge_subtotal_amount$1, t1.subtotal_amount, t2.subtotal_amount),
          total_amount: Curry._2(merge_total_amount$1, t1.total_amount, t2.total_amount),
          untaxed: Curry._2(merge_untaxed, t1.untaxed, t2.untaxed)
        };
}

function spec$2(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "item_type",
                    "itemType"
                  ],
                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.ItemType),
                  Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.ItemType.from_int_exn, 0)
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        6,
                        "name",
                        "name"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            7,
                            "section_code",
                            "sectionCode"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                8,
                                "section_name",
                                "sectionName"
                              ],
                              Ocaml_protoc_plugin__Spec.string,
                              ""
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                  [
                                    9,
                                    "currency_code",
                                    "currencyCode"
                                  ],
                                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency),
                                  Curry._1(Buhta_commonapis__Buhta_common_v1_iso4217.Buhta.Common.V1.Currency.from_int_exn, 0)
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                      [
                                        10,
                                        "item_price",
                                        "itemPrice"
                                      ],
                                      Ocaml_protoc_plugin__Spec.string,
                                      ""
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                          [
                                            11,
                                            "qty",
                                            "qty"
                                          ],
                                          Ocaml_protoc_plugin__Spec.string,
                                          ""
                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                              [
                                                12,
                                                "measure_unit_code",
                                                "measureUnitCode"
                                              ],
                                              Ocaml_protoc_plugin__Spec.int32_int,
                                              0
                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                  [
                                                    13,
                                                    "measure_unit",
                                                    "measureUnit"
                                                  ],
                                                  Ocaml_protoc_plugin__Spec.string,
                                                  ""
                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                      [
                                                        14,
                                                        "measure_unit_short",
                                                        "measureUnitShort"
                                                      ],
                                                      Ocaml_protoc_plugin__Spec.string,
                                                      ""
                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                          [
                                                            15,
                                                            "subtotal_amount",
                                                            "subtotalAmount"
                                                          ],
                                                          Ocaml_protoc_plugin__Spec.string,
                                                          ""
                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                              [
                                                                16,
                                                                "total_amount",
                                                                "totalAmount"
                                                              ],
                                                              Ocaml_protoc_plugin__Spec.string,
                                                              ""
                                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                  [
                                                                    17,
                                                                    "untaxed",
                                                                    "untaxed"
                                                                  ],
                                                                  Ocaml_protoc_plugin__Spec.bool,
                                                                  false
                                                                ]), Ocaml_protoc_plugin__Spec.nil)))))))))))));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry.app(serialize$2, [
        writer,
        param.item_type,
        param.name,
        param.section_code,
        param.section_name,
        param.currency_code,
        param.item_price,
        param.qty,
        param.measure_unit_code,
        param.measure_unit,
        param.measure_unit_short,
        param.subtotal_amount,
        param.total_amount,
        param.untaxed
      ]);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(item_type, name, section_code, section_name, currency_code, item_price, qty, measure_unit_code, measure_unit, measure_unit_short, subtotal_amount, total_amount, untaxed) {
  return {
          item_type: item_type,
          name: name,
          section_code: section_code,
          section_name: section_name,
          currency_code: currency_code,
          item_price: item_price,
          qty: qty,
          measure_unit_code: measure_unit_code,
          measure_unit: measure_unit,
          measure_unit_short: measure_unit_short,
          subtotal_amount: subtotal_amount,
          total_amount: total_amount,
          untaxed: untaxed
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ReceiptItem", spec$2(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
                param.item_type,
                param.name,
                param.section_code,
                param.section_name,
                param.currency_code,
                param.item_price,
                param.qty,
                param.measure_unit_code,
                param.measure_unit,
                param.measure_unit_short,
                param.subtotal_amount,
                param.total_amount,
                param.untaxed
              ]);
  };
}

function constructor$5(item_type, name, section_code, section_name, currency_code, item_price, qty, measure_unit_code, measure_unit, measure_unit_short, subtotal_amount, total_amount, untaxed) {
  return {
          item_type: item_type,
          name: name,
          section_code: section_code,
          section_name: section_name,
          currency_code: currency_code,
          item_price: item_price,
          qty: qty,
          measure_unit_code: measure_unit_code,
          measure_unit: measure_unit,
          measure_unit_short: measure_unit_short,
          subtotal_amount: subtotal_amount,
          total_amount: total_amount,
          untaxed: untaxed
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ReceiptItem", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ReceiptItem, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

function name$3(param) {
  return ".buhta.kassa.v1alpha1.ReceiptPayment";
}

function make$3(payment_typeOpt, amountOpt, param) {
  const payment_type = payment_typeOpt !== undefined ? payment_typeOpt : Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.PaymentType.from_int_exn, 0);
  const amount = amountOpt !== undefined ? amountOpt : "";
  return {
          payment_type: payment_type,
          amount: amount
        };
}

const merge_payment_type$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "payment_type",
            "paymentType"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.PaymentType),
          Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.PaymentType.from_int_exn, 0)
        ]));

const merge_amount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "amount",
            "amount"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge$3(t1, t2) {
  return {
          payment_type: Curry._2(merge_payment_type$1, t1.payment_type, t2.payment_type),
          amount: Curry._2(merge_amount, t1.amount, t2.amount)
        };
}

function spec$3(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "payment_type",
                    "paymentType"
                  ],
                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.PaymentType),
                  Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.PaymentType.from_int_exn, 0)
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "amount",
                        "amount"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
    });

function to_proto$p$3(writer, param) {
  Curry._3(serialize$3, writer, param.payment_type, param.amount);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(payment_type, amount) {
  return {
          payment_type: payment_type,
          amount: amount
        };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
    });

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$3, writer);
            });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ReceiptPayment", spec$3(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.payment_type, param.amount);
  };
}

function constructor$7(payment_type, amount) {
  return {
          payment_type: payment_type,
          amount: amount
        };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ReceiptPayment", spec$3(undefined), constructor$7);
    });

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$3, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ReceiptPayment, {
      make: make$3,
      to_proto: to_proto$3,
      from_proto: from_proto$3,
      to_json: to_json$3,
      from_json: from_json$3,
      name: name$3,
      merge: merge$3,
      to_proto$p: to_proto$p$3,
      from_proto_exn: from_proto_exn$3,
      from_json_exn: from_json_exn$3
    });

function name$4(param) {
  return ".buhta.kassa.v1alpha1.ReceiptTax";
}

function make$4(tax_typeOpt, inclusiveOpt, percentOpt, tax_amountOpt, param) {
  const tax_type = tax_typeOpt !== undefined ? tax_typeOpt : Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.TaxType.from_int_exn, 0);
  const inclusive = inclusiveOpt !== undefined ? inclusiveOpt : false;
  const percent = percentOpt !== undefined ? percentOpt : "";
  const tax_amount = tax_amountOpt !== undefined ? tax_amountOpt : "";
  return {
          tax_type: tax_type,
          inclusive: inclusive,
          percent: percent,
          tax_amount: tax_amount
        };
}

const merge_tax_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "tax_type",
            "taxType"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.TaxType),
          Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.TaxType.from_int_exn, 0)
        ]));

const merge_inclusive = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "inclusive",
            "inclusive"
          ],
          Ocaml_protoc_plugin__Spec.bool,
          false
        ]));

const merge_percent = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "percent",
            "percent"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_tax_amount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            4,
            "tax_amount",
            "taxAmount"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge$4(t1, t2) {
  return {
          tax_type: Curry._2(merge_tax_type, t1.tax_type, t2.tax_type),
          inclusive: Curry._2(merge_inclusive, t1.inclusive, t2.inclusive),
          percent: Curry._2(merge_percent, t1.percent, t2.percent),
          tax_amount: Curry._2(merge_tax_amount, t1.tax_amount, t2.tax_amount)
        };
}

function spec$4(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "tax_type",
                    "taxType"
                  ],
                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.TaxType),
                  Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.TaxType.from_int_exn, 0)
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "inclusive",
                        "inclusive"
                      ],
                      Ocaml_protoc_plugin__Spec.bool,
                      false
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "percent",
                            "percent"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                4,
                                "tax_amount",
                                "taxAmount"
                              ],
                              Ocaml_protoc_plugin__Spec.string,
                              ""
                            ]), Ocaml_protoc_plugin__Spec.nil))));
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
    });

function to_proto$p$4(writer, param) {
  Curry._5(serialize$4, writer, param.tax_type, param.inclusive, param.percent, param.tax_amount);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8(tax_type, inclusive, percent, tax_amount) {
  return {
          tax_type: tax_type,
          inclusive: inclusive,
          percent: percent,
          tax_amount: tax_amount
        };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
    });

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$4, writer);
            });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ReceiptTax", spec$4(undefined))(options);
  return function (param) {
    return Curry._4(serialize, param.tax_type, param.inclusive, param.percent, param.tax_amount);
  };
}

function constructor$9(tax_type, inclusive, percent, tax_amount) {
  return {
          tax_type: tax_type,
          inclusive: inclusive,
          percent: percent,
          tax_amount: tax_amount
        };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ReceiptTax", spec$4(undefined), constructor$9);
    });

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$4, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ReceiptTax, {
      make: make$4,
      to_proto: to_proto$4,
      from_proto: from_proto$4,
      to_json: to_json$4,
      from_json: from_json$4,
      name: name$4,
      merge: merge$4,
      to_proto$p: to_proto$p$4,
      from_proto_exn: from_proto_exn$4,
      from_json_exn: from_json_exn$4
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ReceiptNote"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Receipt"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ReceiptItem"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ReceiptPayment"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ReceiptTax"
        ]
      ]
    }, V1alpha1, {
      Receipt: Receipt,
      ReceiptItem: ReceiptItem,
      ReceiptPayment: ReceiptPayment,
      ReceiptTax: ReceiptTax
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ReceiptNote"
                    ],
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Receipt"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ReceiptItem"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ReceiptPayment"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ReceiptTax"
              ]
            ]
          },
          "V1alpha1"
        ]]
    }, Kassa, {
      V1alpha1: V1alpha1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "ReceiptNote"
                          ],
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "Receipt"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ReceiptItem"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ReceiptPayment"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ReceiptTax"
                    ]
                  ]
                },
                "V1alpha1"
              ]]
          },
          "Kassa"
        ]]
    }, Buhta, {
      Kassa: Kassa
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
